import { inheritSerialization, autoserialize } from 'cerialize';
import { TransitProgram } from './transit-program';

@inheritSerialization(TransitProgram)
export class TransitProgramDetail extends TransitProgram {
  @autoserialize
  requiresOnboardingDrugScreening: boolean;

  @autoserialize
  requiresRandomDrugScreening: boolean;
}
